import $ from "zeptojs";
import Device from "utils/Device";

function generateVerseNode(breakpoint, landscape) {
  const $node = $("<div />")
    .attr("data-verse-player-size", breakpoint)
    .attr("data-orientation", landscape ? "landscape" : "portrait")
    .addClass("verse")
    .appendTo("body");

  // Add `data-landscape-iphone` and `data-is-iphone` only if necessary.
  // Setting either to `false` is not acceptable because the css tests for
  // it's mere existence. Setting it to `false` will set the attribute to
  // have a string value of `"false"`, which is still truthy.

  if (Device.isiPhone && landscape) {
    $node.attr("data-landscape-iphone", true);
  }

  if (Device.isiPhone) {
    $node.attr("data-is-iphone", true);
  }

  return $node.get(0);
}

export default function getCssValueFromDefinition({
  breakpoint,
  property,
  landscape,
  cssKey,
}) {
  const node = generateVerseNode(breakpoint, landscape);
  const $node = $(node);

  const rawValue = $("<div />")
    .addClass(`${property} definition`)
    .appendTo($node)
    .css(cssKey);
  const value = parseFloat(rawValue);

  $node.detach();

  return value;
}
